import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { addNoteToSale } from "../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    to: "sale" | "internal" | Array<number> | "callback";
    note: string;
    required?: boolean;
    callback?: (note: string) => void;
    dispatch: ThunkDispatch<any, any, any>;
}

interface State {
    note: string;
}

class AddNote extends React.Component<Props, State> {
    protected inputRef: React.RefObject<HTMLTextAreaElement | null>;

    constructor(props: Props) {
        super(props);

        this.state = {
            note: props.note ? props.note : "",
        };

        this.inputRef = React.createRef();

        this.handleAdd = this.handleAdd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleNoteChange = this.handleNoteChange.bind(this);
    }

    public componentDidMount(): void {
        this.focus();
    }

    protected focus(): void {
        if(this.inputRef.current) {
            // Select the end of the input
            this.inputRef.current.focus();
            this.inputRef.current.selectionStart =
                this.inputRef.current.selectionEnd =
                    this.inputRef.current.value.length;
        }
    }

    protected handleNoteChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        const value = e.currentTarget.value;

        this.setState({
            note: value,
        });
    }

    protected handleAdd(e: React.MouseEvent): void {
        if(this.props.required && !this.state.note.trim()) {
            e.stopPropagation();
            PopupManager.error("A note is required");
            this.focus();

            return;
        }

        if(typeof this.props.callback === "function") {
            this.props.callback(this.state.note);
        }

        if(this.props.to !== "callback") {
            this.props.dispatch(addNoteToSale(this.props.to, this.state.note));
        }

        this.props.dispatch(hideDialog());
    }

    protected handleCancel(): void {
        this.props.dispatch(hideDialog());
    }

    public render(): React.ReactNode {
        return (
            <div className="add-note-to-sale">
                <textarea
                    ref={this.inputRef}
                    name="add-note"
                    value={this.state.note}
                    onChange={this.handleNoteChange}
                    style={{
                        width    : "20vw",
                        height   : "20vh",
                        minWidth : "200px",
                        minHeight: "100px",
                    }}
                />
                <div className="buttons">
                    <Button type="button" classes={[ "button-cancel" ]} onClick={this.handleCancel}>Cancel</Button>
                    <Button type="button" classes={[ "button-save" ]} onClick={this.handleAdd} >Add</Button>
                </div>
            </div>
        );
    }
}

export default connector(AddNote);
